import styles from "./EarningsPerShare.module.scss";
import { FC, lazy, Suspense } from "react";
import { withStockStamp } from "@/components/stock-stamp-hoc/StockStampHOC";
import { classNames } from "@/lib/utils";
import { Box, CircularProgress, Typography } from "@mui/material";
const MUILineChart = lazy(() => import("@/components/line-chart/MUILineChart"));

interface PropsTypes {
    epsChangeWeek: number;
    epsChangeWeekCss: string;
    epsTs: number[];
    overviewPage?: boolean;
    row?: any;
    mobile?: boolean;
    obfuscated?: boolean;
}

const EarningsPerShare: FC<PropsTypes> = ({ epsChangeWeek, epsChangeWeekCss, epsTs, overviewPage, row, mobile, obfuscated = false }) => {
    return overviewPage ? (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <Box sx={{ height: "40%" }}>
                <Typography variant={mobile ? "h2" : "moduleContentTitle"} className={epsChangeWeekCss}>
                    {epsChangeWeek?.toFixed(2)}%
                </Typography>
            </Box>
            <Box sx={{ height: "60%" }}>
                <Suspense
                    fallback={
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                            <CircularProgress size={30} />
                        </div>
                    }
                >
                    <MUILineChart data={epsTs} id={row && row.stock.ticker + row.divergence.box_name} labels={["-3m", "-2m", "-1m"]} labelsAlign={"left"} obfuscated={obfuscated} />
                </Suspense>
            </Box>
        </Box>
    ) : (
        <div className={classNames(styles.EarningsPerShare, styles[overviewPage && "overview-page"])}>
            <Typography variant={mobile ? "h2" : "moduleContentTitle"} className={epsChangeWeekCss}>
                {epsChangeWeek?.toFixed(2)}%
            </Typography>

            <Box>
                <Suspense
                    fallback={
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                            <CircularProgress size={30} />
                        </div>
                    }
                >
                    <MUILineChart data={epsTs} id={row && row.stock.ticker + row.divergence.box_name} labels={["-3m", "-2m", "-1m"]} labelsAlign={"left"} obfuscated={obfuscated} />
                </Suspense>
            </Box>
        </div>
    );
};

export default withStockStamp(EarningsPerShare, "epsChangeWeek", { title: "EPS 5D" }, "EPS");
